import api from '../../services/api'

// Helper to get favorite group from accessibility settings
const getFavoriteGroupId = () => {
  try {
    const stored = JSON.parse(localStorage.getItem('accessibility_settings') || '{}')
    return stored.favoriteGroupId || null
  } catch {
    return null
  }
}

export default {
  namespaced: true,
  
  state: {
    user: JSON.parse(localStorage.getItem('user')) || null,
    token: localStorage.getItem('token') || null,
    isAuthenticated: !!localStorage.getItem('token')
  },
  
  getters: {
    user: state => state.user,
    token: state => state.token,
    isAuthenticated: state => state.isAuthenticated
  },
  
  mutations: {
    SET_USER(state, user) {
      state.user = user
      if (user) {
        localStorage.setItem('user', JSON.stringify(user))
      } else {
        localStorage.removeItem('user')
      }
    },
    SET_TOKEN(state, token) {
      state.token = token
      state.isAuthenticated = !!token
      if (token) {
        localStorage.setItem('token', token)
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`
      } else {
        localStorage.removeItem('token')
        delete api.defaults.headers.common['Authorization']
      }
    },
    LOGOUT(state) {
      state.user = null
      state.token = null
      state.isAuthenticated = false
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      delete api.defaults.headers.common['Authorization']
    }
  },
  
  actions: {
    async login({ commit }, credentials) {
      try {
        const response = await api.post('/auth/login', credentials)
        const { token, user } = response.data
        commit('SET_TOKEN', token)
        commit('SET_USER', user)
        
        // Determine redirect path based on favorite group
        const favoriteGroupId = getFavoriteGroupId()
        const redirectTo = favoriteGroupId ? `/groups/${favoriteGroupId}` : '/wall'
        
        return { success: true, redirectTo }
      } catch (error) {
        return { success: false, error: error.response?.data?.message || 'Login failed' }
      }
    },
    
    logout({ commit }) {
      commit('LOGOUT')
    },
    
    initAuth({ commit }) {
      const token = localStorage.getItem('token')
      const user = localStorage.getItem('user')
      if (token && user) {
        commit('SET_TOKEN', token)
        commit('SET_USER', JSON.parse(user))
      }
    }
  }
}